<script>
export default {
  name: 'SkistarResortWrapper',
};
</script>

<template>
  <v-container>
    <v-layout row>
      <v-flex xs12>
        <v-tabs dark>
          <v-tab key="accommodation" to="accommodations">Accommodations</v-tab>
          <v-tab key="addons" to="addons">Addons</v-tab>
          <v-tab key="unhandled-images" to="unhandled-images">Unhandled Images</v-tab>
        </v-tabs>
        <router-view/>
      </v-flex>
    </v-layout>
  </v-container>
</template>



// WEBPACK FOOTER //
// src/pages/ski/skistar/SkistarResortWrapper.vue